'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
import * as $j_scala$002eruntime$002e$002dTuples$0024 from "./scala.runtime.-Tuples$.js";
var $p;
/** @constructor */
function $c_Lbe_doeraene_webcomponents_ui5_configkeys_EnumerationString$TupleValueOf(value) {
  this.lr = null;
  this.lr = value;
}
export { $c_Lbe_doeraene_webcomponents_ui5_configkeys_EnumerationString$TupleValueOf as $c_Lbe_doeraene_webcomponents_ui5_configkeys_EnumerationString$TupleValueOf };
$p = $c_Lbe_doeraene_webcomponents_ui5_configkeys_EnumerationString$TupleValueOf.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lbe_doeraene_webcomponents_ui5_configkeys_EnumerationString$TupleValueOf;
/** @constructor */
function $h_Lbe_doeraene_webcomponents_ui5_configkeys_EnumerationString$TupleValueOf() {
}
export { $h_Lbe_doeraene_webcomponents_ui5_configkeys_EnumerationString$TupleValueOf as $h_Lbe_doeraene_webcomponents_ui5_configkeys_EnumerationString$TupleValueOf };
$h_Lbe_doeraene_webcomponents_ui5_configkeys_EnumerationString$TupleValueOf.prototype = $p;
$p.I = (function() {
  return new $j_java$002elang$002e$002dObject.$c_s_Product$$anon$1(this);
});
$p.m = (function() {
  return $j_java$002elang$002e$002dObject.$m_s_util_hashing_MurmurHash3$().e7(this, (-889275714), null);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lbe_doeraene_webcomponents_ui5_configkeys_EnumerationString$TupleValueOf)) {
    var x = this.lr;
    var x$2 = x$0.lr;
    return ((x === null) ? (x$2 === null) : x.f(x$2));
  } else {
    return false;
  }
});
$p.b = (function() {
  return $j_java$002elang$002e$002dObject.$m_sr_ScalaRunTime$().ah(this);
});
$p.n = (function() {
  return 1;
});
$p.o = (function() {
  return "TupleValueOf";
});
$p.g = (function(n) {
  if ((n === 0)) {
    return this.lr;
  }
  throw $j_java$002elang$002e$002dObject.$ct_jl_IndexOutOfBoundsException__T__(new $j_java$002elang$002e$002dObject.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.QJ = (function(x$1) {
  var this$1 = $j_java$002elang$002e$002dObject.$m_s_Predef$().iy($j_scala$002eruntime$002e$002dTuples$0024.$m_sr_Tuples$().Y1(this.lr));
  $j_java$002elang$002e$002dObject.$m_sci_List$();
  var this$4 = $j_java$002elang$002e$002dObject.$m_sci_Nil$().bW(this$1);
  var f = ((_$1) => _$1);
  if ((this$4 === $j_java$002elang$002e$002dObject.$m_sci_Nil$())) {
    var $x_1 = $j_java$002elang$002e$002dObject.$m_sci_Nil$();
  } else {
    var x0 = this$4.E();
    var h = new $j_java$002elang$002e$002dObject.$c_sci_$colon$colon(f(x0), $j_java$002elang$002e$002dObject.$m_sci_Nil$());
    var t = h;
    var rest = this$4.H();
    while ((rest !== $j_java$002elang$002e$002dObject.$m_sci_Nil$())) {
      var x0$1 = rest.E();
      var nx = new $j_java$002elang$002e$002dObject.$c_sci_$colon$colon(f(x0$1), $j_java$002elang$002e$002dObject.$m_sci_Nil$());
      t.ao = nx;
      t = nx;
      rest = rest.H();
    }
    var $x_1 = h;
  }
  return $x_1;
});
function $isArrayOf_Lbe_doeraene_webcomponents_ui5_configkeys_EnumerationString$TupleValueOf(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.cK)));
}
export { $isArrayOf_Lbe_doeraene_webcomponents_ui5_configkeys_EnumerationString$TupleValueOf as $isArrayOf_Lbe_doeraene_webcomponents_ui5_configkeys_EnumerationString$TupleValueOf };
var $d_Lbe_doeraene_webcomponents_ui5_configkeys_EnumerationString$TupleValueOf = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lbe_doeraene_webcomponents_ui5_configkeys_EnumerationString$TupleValueOf, "be.doeraene.webcomponents.ui5.configkeys.EnumerationString$TupleValueOf", ({
  cK: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lbe_doeraene_webcomponents_ui5_configkeys_EnumerationString$TupleValueOf as $d_Lbe_doeraene_webcomponents_ui5_configkeys_EnumerationString$TupleValueOf };
